import { Dialog } from "@headlessui/react";
import { useEffect, useState } from "react";
import { getUserList } from "../../services/ api_services";
import { isEmpty } from "lodash";

const OrgMemberDialog = ({ isOpen, onClose, orgId }) => {
    const [list, setList] = useState([]);
    const [id, setId] = useState(orgId);

    useEffect(() => {
        const data = {
            page_number: 1,
            page_size: 100,
            search_word: '',
            search_type: '',
            search_org: null,
            view_referrer: "True",  // org_id 값을 가진 회원(추천인 후보)만 보이도록 True값
            admin_level_cd: '',
            admin_org_id: id,
        };

        fetchUserList(data);
    }, [orgId]);

    async function fetchUserList(data) {

        console.log("OrgMemberDialog data ==>", data);
        try {
            const response = await getUserList(data);
            console.log("🚀 ~ OrgMemberDialog fetchUserList ~ response:", response);

            if (response.status === 200 && !isEmpty(response.data)) {
                const data = response.data.filter((item) => item.org_id === id);
                setList(data);
            } else {
                setList([]);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    }

    return (
        <Dialog
            as="div"
            className="relative z-50"
            open={isOpen} // showPopup에 전달
            onClose={onClose}
            aria-label="조직도 회원 리스트"
        >
        <div className="fixed inset-0 bg-black bg-opacity-40 z-40">
            <div className="fixed inset-0 flex justify-center items-center z-50">
                <Dialog.Panel className="bg-white rounded-md p-6 max-w-4xl w-full max-h-[80vh] overflow-y-auto shadow-lg">
                    <table className="min-w-full divide-y divide-gray-300">
                    <thead className="sticky top-0 bg-white">
                        <tr>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">번호</th>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">조직명</th>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">소속 회원명</th>
                        <th scope="col" className="p-3 text-left text-center text-sm font-semibold text-gray-900">휴대폰 번호</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {list.length > 0 ? (
                        list.map((item, idx) => (
                            <tr key={item.id || `row-${idx}`}>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{idx+1}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{item.org_full_path}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{item.user_nm}</td>
                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-500">{item.user_hp_no}</td>
                            </tr>
                        ))
                        ) : (
                        <tr>
                            <td colSpan="6" className="text-center py-4 text-sm text-gray-500">
                            소속된 회원이 없습니다.
                            </td>
                        </tr>
                        )}
                    </tbody>
                    </table>
                </Dialog.Panel>
            </div>
        </div>
    </Dialog>
    );
}

export default OrgMemberDialog;